module.exports = __webpack_public_path__ + "static/media/bergmanSq.8207743a.jpg";